import { createStore } from "vuex";
import axios from "axios";
import router from "./router";

import Modules from "@/store/index";

export default createStore({
  modules: Modules,
});
